import React from "react";
import { Flex, Text, Select, IconButton } from "@radix-ui/themes";
import { ArrowRightIcon } from "@radix-ui/react-icons";

export const BLOOMREACH_SYNC = "sync";
export const BLOOMREACH_SKIP = "skip";

export function BloomreachSyncSelect({
  value,
  onValueChange,
  disabled = false,
  placeholder = "Select...",
}) {
  const label = value === BLOOMREACH_SYNC ? "Sync" : "Don't sync";
  return (
    <Select.Root
      value={value === BLOOMREACH_SYNC ? BLOOMREACH_SYNC : BLOOMREACH_SKIP}
      onValueChange={onValueChange}
      disabled={disabled}
      style={{ width: "100%" }}
    >
      <Select.Trigger placeholder={placeholder} style={{ width: "100%", boxSizing: "border-box" }}>
        <div
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: "100%",
          }}
          title={label}
        >
          {label}
        </div>
      </Select.Trigger>
      <Select.Content side="bottom" align="start" sideOffset={4}>
        <Select.Item value={BLOOMREACH_SYNC}>Sync</Select.Item>
        <Select.Item value={BLOOMREACH_SKIP}>Don't sync</Select.Item>
      </Select.Content>
    </Select.Root>
  );
}

export function BloomreachLocationRow({ loc, value, onValueChange, disabled = false }) {
  const name = loc.name ?? loc.label ?? "";
  return (
    <Flex direction="row" justify="between" style={{ width: "100%" }}>
      <Flex style={{ width: "48%", minWidth: 0 }}>
        <Flex
          style={{
            width: "100%",
            backgroundColor: "var(--gray-3)",
            border: "1px solid var(--gray-a7)",
            borderRadius: "var(--radius-2)",
            padding: "0 var(--space-2)",
            height: "34px",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <Text
            size="2"
            title={name}
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              width: "100%",
              color: "var(--gray-a11)",
            }}
          >
            {name}
          </Text>
        </Flex>
      </Flex>

      <Flex align="center" style={{ paddingLeft: "8px", paddingRight: "8px" }}>
        <IconButton size="2" variant="ghost" color="gray" style={{ pointerEvents: "none" }}>
          <ArrowRightIcon width="16" height="16" />
        </IconButton>
      </Flex>

      <Flex style={{ width: "48%", minWidth: 0 }}>
        <BloomreachSyncSelect value={value} onValueChange={onValueChange} disabled={disabled} />
      </Flex>
    </Flex>
  );
}
